module.exports = __webpack_public_path__ + "img/can.a4ce2914.png";